import {WeChatVoucher} from '@/api/common';
import wx from 'weixin-js-sdk';

// 票据
export function Voucher(url, api) {
    return new Promise((resolve, reject) => {
        WeChatVoucher(url, api).then(voucher => {
            wx.config(voucher);
            wx.ready(() => {
                console.log('wx.ready');
                resolve(wx);
            });
            wx.error((res) => {
                console.log('wx err', res);
                reject(res);
            });
        }).catch(() => {
            reject('接口异常');
        });
    });
}

// 分享
export function Share(title, thumbnail, description, url, type = 'link') {
    return new Promise((resolve, reject) => {
        Voucher(url, 'onMenuShareTimeline,onMenuShareAppMessage').then(_wx => {
            _wx.onMenuShareTimeline({
                title: title, // 分享标题
                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: thumbnail, // 分享图标
                success() {
                    // 用户点击了分享后执行的回调函数
                    resolve();
                }
            });

            _wx.onMenuShareAppMessage({
                title: title, // 分享标题
                desc: description, // 分享描述
                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: thumbnail, // 分享图标
                type: type, // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success() {
                    // 用户点击了分享后执行的回调函数
                    resolve();
                }
            });
        }).catch(err => {
            reject(err)
        });
    });
}

// 选择照片
export function ChooseImage(_wx, count = 9, sizeType = ['original', 'compressed'], sourceType = ['album', 'camera']) {
    return new Promise((resolve, reject) => {
        // Voucher(url, 'chooseImage,previewImage,uploadImage,downloadImage').then(_wx => {
        _wx.chooseImage({
            count, // 默认9
            sizeType, // 可以指定是原图还是压缩图，默认二者都有
            sourceType, // 可以指定来源是相册还是相机，默认二者都有
            success(res) {
                // var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                resolve(res.localIds, _wx);
            }
        });
        // }).catch(err => {
        //     reject(err)
        // });
    });
}